import React from 'react';
import { Container, Card, Button, Alert } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('💥 React Error Boundary Caught Exception:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container className="d-flex justify-content-center align-items-center min-vh-100 py-5">
          <Card className="shadow-lg border-0 text-center p-4" style={{ maxWidth: '550px', width: '100%' }}>
            <Card.Body>
              <div className="mb-3" style={{ fontSize: '3rem' }}>⚠️</div>
              <h3 className="fw-bold text-danger mb-3">Something Went Wrong</h3>
              <p className="text-muted mb-4">
                An unexpected UI rendering error occurred. The system trapped the error safely to prevent application crash.
              </p>
              {this.state.error && (
                <Alert variant="danger" className="text-start small mb-4 font-monospace">
                  {this.state.error.toString()}
                </Alert>
              )}
              <Button variant="primary" onClick={this.handleReload} className="px-4 py-2 fw-semibold">
                🔄 Reload Application
              </Button>
            </Card.Body>
          </Card>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
